// import React, { useState } from 'react';
import AppLoader from 'components/general/AppLoader';
import { Col, Row, Button, Form } from "react-bootstrap";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { isMemberEquivalent } from 'utils/acl';
import { notifyEditPermissionDenied } from 'utils/editPermissionToast';
// import { ArrowRightCircle } from 'react-bootstrap-icons'

export default function Event({ item, onItemTitleChange }) {
  const [editing, setEditing] = useState(false);
  const [inputValue, setInputValue] = useState(item?.item_title || "");
  const [loading, setLoading] = useState(false);
  const [subtitleEditing, setSubtitleEditing] = useState(false);
  const [subtitleInputValue, setSubtitleInputValue] = useState(item?.item_subtitle || "");
  const [subtitleLoading, setSubtitleLoading] = useState(false);
  const { user: authUser } = useSelector(x => x.auth) || {};
  const url = process.env.REACT_APP_URL;
  const acl = String(authUser?.user?.acl || authUser?.acl || '').trim();
  const canEditAgendaText = Boolean(authUser?.token && isMemberEquivalent(acl));

  // Reset editing when item changes
  useEffect(() => {
    setEditing(false);
    setInputValue(item?.item_title || "");
    setSubtitleEditing(false);
    setSubtitleInputValue(item?.item_subtitle || "");
  }, [item]);

  // Save or remove item_title in backend
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!canEditAgendaText) {
      notifyEditPermissionDenied(authUser);
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(`${url}/agendaItem/${item.agendaItemId}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + (authUser?.token || '')
        },
        body: JSON.stringify({
          item_title: inputValue.trim() ? inputValue : null // Send null if empty
        })
      });
      if (res.status !== 200 && res.status !== 201) {
        throw new Error('(' + res.status + ') Could not save title');
      }
      const data = await res.json();
      // Update inputValue with the latest value from backend
      setInputValue(data.item_title || "");
      if (onItemTitleChange) {
        await onItemTitleChange(data.item_title || "");
      }
      // Also update item.item_title if possible (if item is mutable)
      if (item && typeof item === 'object') {
        item.item_title = data.item_title || "";
      }
      setEditing(false);
    } catch (err) {
      // Optionally show error (toast, alert, etc.)
      alert(err);
    }
    setLoading(false);
  };

  const handleCancel = () => {
    setInputValue(item?.item_title || "");
    setEditing(false);
  };

  const handleEditClick = () => {
    if (!canEditAgendaText) {
      notifyEditPermissionDenied(authUser);
      return;
    }
    setEditing(true);
    setInputValue(item?.item_title || "");
  };

  // Subtitle handlers
  const handleSubtitleSubmit = async (e) => {
    e.preventDefault();
    if (!canEditAgendaText) {
      notifyEditPermissionDenied(authUser);
      return;
    }
    setSubtitleLoading(true);
    try {
      const res = await fetch(`${url}/agendaItem/${item.agendaItemId}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + (authUser?.token || '')
        },
        body: JSON.stringify({
          item_subtitle: subtitleInputValue.trim() ? subtitleInputValue : null
        })
      });
      if (res.status !== 200 && res.status !== 201) {
        throw new Error('(' + res.status + ') Could not save subtitle');
      }
      const data = await res.json();
      setSubtitleInputValue(data.item_subtitle || "");
      if (item && typeof item === 'object') {
        item.item_subtitle = data.item_subtitle || "";
      }
      setSubtitleEditing(false);
    } catch (err) {
      alert(err);
    }
    setSubtitleLoading(false);
  };

  const handleSubtitleCancel = () => {
    setSubtitleInputValue(item?.item_subtitle || "");
    setSubtitleEditing(false);
  };

  const handleSubtitleEditClick = () => {
    if (!canEditAgendaText) {
      notifyEditPermissionDenied(authUser);
      return;
    }
    setSubtitleEditing(true);
    setSubtitleInputValue(item?.item_subtitle || "");
  };

  return (
    <>
      <Row>
        <Col>
          {/* <h4 className='text-inline'>{item?.startTime}</h4> */}
          <h1 className='text-inline role-title-centered'>
            <span
              className={item?.activity?.type === 'debate' ? 'activity-debate-event-name' : undefined}
              style={{ cursor: canEditAgendaText ? 'pointer' : 'default' }}
              onClick={() => !editing && handleEditClick()}
              title={canEditAgendaText ? (item?.item_title ? 'Edit title' : 'Add title') : ''}
            >
              {item?.activity?.type === 'debate' ? 'DEBATE' : item?.agendaEvent?.name}
            </span>
            <br />
            {/* Inline edit/add for item_title */}
            {editing ? (
              <Form onSubmit={handleSubmit} style={{}}>
                <Row>
                  <Col style={{ position: 'relative' }}>
                    <Form.Control
                      size="sm"
                      type="text"
                      value={inputValue}
                      onChange={e => setInputValue(e.target.value)}
                      autoFocus
                      style={{ padding: inputValue ? '0 28px 0 10px' : '0 10px' }}
                      placeholder="Enter title"
                    />
                    {inputValue && (
                      <button
                        type="button"
                        aria-label="Clear"
                        onClick={() => setInputValue("")}
                        style={{
                          position: 'absolute',
                          right: 20,
                          top: '50%',
                          transform: 'translateY(-50%)',
                          border: 'none',
                          background: 'transparent',
                          padding: 0,
                          margin: 0,
                          cursor: 'pointer',
                          // fontSize: '1.1em',
                          color: 'var(--foreground)',
                          lineHeight: 1,
                          zIndex: 2
                        }}
                        tabIndex={-1}
                      >
                        ×
                      </button>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Button
                      variant="success"
                      size="sm"
                      type="submit"
                      disabled={loading}
                      style={{ padding: '0 14px', alignItems: 'center', marginRight: '10px' }}

                    >
                      {loading ? <AppLoader size="sm" inline /> : 'Save'}
                    </Button>
                    <Button
                      variant="secondary"
                      size="sm"
                      type="button"
                      onClick={handleCancel}
                      style={{ padding: '0 14px', alignItems: 'center' }}
                    >
                      Cancel
                    </Button>
                  </Col>
                </Row>

              </Form>
            ) : (
              !item?.hideTitleAndSubtitle && item?.item_title && (
                <span
                  style={{ marginLeft: 8, fontSize: '0.95em', cursor: canEditAgendaText ? 'pointer' : 'default' }}
                  onClick={() => !editing && handleEditClick()}
                  title={canEditAgendaText ? 'Edit title' : ''}
                >
                  {item.item_title}
                </span>
              )
            )}
          </h1>
          {/* Editable subtitle */}
          {!item?.hideTitleAndSubtitle && (subtitleEditing ? (
            <Form onSubmit={handleSubtitleSubmit} style={{ marginTop: 4 }}>
              <Row>
                <Col style={{ position: 'relative' }}>
                  <Form.Control
                    size="sm"
                    type="text"
                    value={subtitleInputValue}
                    onChange={e => setSubtitleInputValue(e.target.value)}
                    autoFocus
                    style={{ padding: subtitleInputValue ? '0 28px 0 10px' : '0 10px' }}
                    placeholder="Enter subtitle"
                  />
                  {subtitleInputValue && (
                    <button
                      type="button"
                      aria-label="Clear"
                      onClick={() => setSubtitleInputValue("")}
                      style={{
                        position: 'absolute',
                        right: 20,
                        top: '50%',
                        transform: 'translateY(-50%)',
                        border: 'none',
                        background: 'transparent',
                        padding: 0,
                        margin: 0,
                        cursor: 'pointer',
                        color: 'var(--foreground)',
                        lineHeight: 1,
                        zIndex: 2
                      }}
                      tabIndex={-1}
                    >
                      ×
                    </button>
                  )}
                </Col>
              </Row>
              <Row>
                <Col>
                  <Button
                    variant="success"
                    size="sm"
                    type="submit"
                    disabled={subtitleLoading}
                    style={{ padding: '0 14px', alignItems: 'center', marginRight: '10px' }}
                  >
                    {subtitleLoading ? <AppLoader size="sm" inline /> : 'Save'}
                  </Button>
                  <Button
                    variant="secondary"
                    size="sm"
                    type="button"
                    onClick={handleSubtitleCancel}
                    style={{ padding: '0 14px', alignItems: 'center' }}
                  >
                    Cancel
                  </Button>
                </Col>
              </Row>
            </Form>
          ) : (
            <p
              style={{ fontSize: '1.4em', cursor: canEditAgendaText ? 'pointer' : 'default', color: 'var(--foreground)', opacity: item?.item_subtitle ? 1 : 0.4, marginTop: 4 }}
              onClick={() => !subtitleEditing && handleSubtitleEditClick()}
              title={canEditAgendaText ? (item?.item_subtitle ? 'Edit subtitle' : 'Add subtitle') : ''}
            >
              {item?.item_subtitle || 'Add subtitle...'}
            </p>
          ))}
        </Col>
      </Row>
      {/* <Row>
        <Col xs={1} lg={3}></Col>
        <Col dangerouslySetInnerHTML={{ __html: item?.agendaEvent.description }} style={{ display: showEventDescription ? 'block' : 'none' }}></Col>
        <Col xs={1} lg={3}></Col>
      </Row> */}
    </>
  );
}